import * as React from 'react';
/**
 * @type {React.Context<{ idPrefix: string; value: string } | null>}
 */

var Context = React.createContext(null);
if (process.env.NODE_ENV !== 'production') {
  Context.displayName = 'TabContext';
}
function useUniquePrefix() {
  var _React$useState = React.useState(null),
    id = _React$useState[0],
    setId = _React$useState[1];
  React.useEffect(function () {
    setId("mui-p-".concat(Math.round(Math.random() * 1e5)));
  }, []);
  return id;
}
export default function TabContext(props) {
  var children = props.children,
    value = props.value;
  var idPrefix = useUniquePrefix();
  var context = React.useMemo(function () {
    return {
      idPrefix: idPrefix,
      value: value
    };
  }, [idPrefix, value]);
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: context
  }, children);
}
process.env.NODE_ENV !== "production" ? void 0 : void 0;
/**
 * @returns {unknown}
 */

export function useTabContext() {
  return React.useContext(Context);
}
export function getPanelId(context, value) {
  var idPrefix = context.idPrefix;
  if (idPrefix === null) {
    return null;
  }
  return "".concat(context.idPrefix, "-P-").concat(value);
}
export function getTabId(context, value) {
  var idPrefix = context.idPrefix;
  if (idPrefix === null) {
    return null;
  }
  return "".concat(context.idPrefix, "-T-").concat(value);
}